import { render } from "./studioCourseCreate.vue?vue&type=template&id=5b87f114&scoped=true"
import script from "./studioCourseCreate.vue?vue&type=script&lang=js"
export * from "./studioCourseCreate.vue?vue&type=script&lang=js"

import "./studioCourseCreate.vue?vue&type=style&index=0&id=5b87f114&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b87f114"]])

export default __exports__